import React, { useState } from 'react';
import styled from 'styled-components';
import { theme } from '../styles/theme';
import { FaHome, FaCar, FaCalendarAlt, FaStore, FaUser } from 'react-icons/fa';
import HomePage from './pages/HomePage';
import CarsListingsPage from './pages/CarsListingsPage';
import EventsPage from './pages/EventsPage';
import MarketplacePage from './pages/MarketplacePage';
import ProfilePage from './pages/ProfilePage';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${theme.colors.lightGray};
`;

const MainContent = styled.main`
  flex: 1;
  padding-bottom: 80px; // Space for fixed footer
`;

const Footer = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${theme.colors.white};
  border-top: 1px solid ${theme.colors.lightGray};
  padding: ${theme.spacing.sm} 0;
  z-index: 100;
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 ${theme.spacing.md};
`;

const NavItem = styled.button<{ active: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing.xs};
  background: none;
  border: none;
  padding: ${theme.spacing.sm};
  cursor: pointer;
  transition: all 0.3s ease;
  color: ${props => props.active ? theme.colors.primary : theme.colors.mediumGray};
  font-size: 0.8rem;
  font-weight: ${props => props.active ? '600' : '400'};
  
  &:hover {
    color: ${theme.colors.primary};
  }
`;

const Icon = styled.div<{ active: boolean }>`
  font-size: 1.2rem;
  color: ${props => props.active ? theme.colors.primary : theme.colors.mediumGray};
  transition: all 0.3s ease;
`;

const MainApp: React.FC = () => {
  const [activeTab, setActiveTab] = useState('home');

  const tabs = [
    { id: 'home', label: 'Home', icon: FaHome, component: HomePage },
    { id: 'cars', label: 'Cars', icon: FaCar, component: CarsListingsPage },
    { id: 'events', label: 'Events', icon: FaCalendarAlt, component: EventsPage },
    { id: 'marketplace', label: 'Market', icon: FaStore, component: MarketplacePage },
    { id: 'profile', label: 'Profile', icon: FaUser, component: ProfilePage }
  ];

  const activeTabData = tabs.find(tab => tab.id === activeTab);
  const ActiveComponent = activeTabData?.component || HomePage;

  return (
    <Container>
      <MainContent>
        <ActiveComponent />
      </MainContent>
      
      <Footer>
        <NavContainer>
          {tabs.map((tab) => {
            const IconComponent = tab.icon;
            return (
              <NavItem
                key={tab.id}
                active={activeTab === tab.id}
                onClick={() => setActiveTab(tab.id)}
              >
                <Icon active={activeTab === tab.id}>
                  <IconComponent />
                </Icon>
                {tab.label}
              </NavItem>
            );
          })}
        </NavContainer>
      </Footer>
    </Container>
  );
};

export default MainApp;


